import React from 'react';
import { showLongTextTipsDialog } from 'lib/components/LongTextTipsDialog';
import { create } from 'zustand';
import { report } from 'lib/utils/dataReport';
import { ATTA_GATEWAY_MOBILE } from 'lib/constants/atta';

interface ProtocolState {
  protocolShortText: string;
  protocolText: string;
  isCheckedProtocol: boolean;
  setProtocolText: (text: { protocolShortText: string; protocolText: string }) => void;
  setIsCheckedProtocol: (isChecked: boolean) => void;
  showProtocolDialog: (params: { buttonText: string; onConfirm?: () => void; onClose?: () => void }) => void;
}

export const useProtocolStore = create<ProtocolState>((set) => ({
  protocolShortText: '',
  protocolText: '',
  isCheckedProtocol: false,
  setProtocolText: ({ protocolShortText, protocolText }: { protocolShortText: string; protocolText: string }) => {
    set({ protocolShortText, protocolText });
  },
  setIsCheckedProtocol: (isChecked: boolean) => {
    set({ isCheckedProtocol: isChecked });
  },
  showProtocolDialog: ({ buttonText, onConfirm, onClose }) => {
    const { protocolText } = useProtocolStore.getState();
    report(ATTA_GATEWAY_MOBILE.AGREEMENT_VIEW);
    showLongTextTipsDialog({
      title: '',
      content: <div className="protocol-dialog__text" dangerouslySetInnerHTML={{ __html: protocolText }} />,
      buttonText,
      onConfirm,
      onClose,
    });
  },
}));
